/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoJsonGeometry
 */
export interface OutputGeoJsonGeometry {
    /**
     * 
     * @type {object}
     * @memberof OutputGeoJsonGeometry
     */
    coordinates: object;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoJsonGeometry
     */
    type: string;
}

/**
 * Check if a given object implements the OutputGeoJsonGeometry interface.
 */
export function instanceOfOutputGeoJsonGeometry(value: object): boolean {
    if (!('coordinates' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function OutputGeoJsonGeometryFromJSON(json: any): OutputGeoJsonGeometry {
    return OutputGeoJsonGeometryFromJSONTyped(json, false);
}

export function OutputGeoJsonGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoJsonGeometry {
    if (json == null) {
        return json;
    }
    return {
        
        'coordinates': json['coordinates'],
        'type': json['type'],
    };
}

export function OutputGeoJsonGeometryToJSON(value?: OutputGeoJsonGeometry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coordinates': value['coordinates'],
        'type': value['type'],
    };
}

